const TokenSpec = {
  /** Minimum allowed length of token names */
  minTokenNameSize: 1,
  /** Maximum allowed length of token names */
  maxTokenNameSize: 25
};
export default TokenSpec;
